class PorteoCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.porteo-carousel-track');
    this.slides = Array.from(this.querySelectorAll('.porteo-carousel-slide'));
    this.dotsWrap = this.closest('.porteo-container')?.querySelector('.porteo-carousel-dots');
    this.index = 0;
    this.autoplaySeconds = parseInt(this.dataset.autoplay || '0', 10);
    this.timer = null;

    // Si hay menos tarjetas visibles (ej. Nanuu con menos posturas) que columnas
    // configuradas, ajusta las columnas al numero real para que se centren en
    // vez de dejar espacio vacio a la derecha.
    const configuredCols = parseInt(getComputedStyle(this).getPropertyValue('--porteo-cols-desktop')) || 3;
    const effectiveCols = Math.min(configuredCols, this.slides.length || 1);
    this.style.setProperty('--porteo-cols-desktop', effectiveCols);

    if (this.slides.length <= 1) return;

    this.buildDots();
    this.bindSwipe();
    this.startAutoplay();

    window.addEventListener('resize', () => this.update());
  }

  buildDots() {
    if (!this.dotsWrap) return;
    this.dotsWrap.innerHTML = '';
    this.slides.forEach((_, i) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.setAttribute('aria-label', 'Ir a ' + (i + 1));
      if (i === 0) btn.classList.add('active');
      btn.addEventListener('click', () => {
        this.index = i;
        this.update();
        this.restartAutoplay();
      });
      this.dotsWrap.appendChild(btn);
    });
  }

  update() {
    if (window.innerWidth >= 750) return;
    if (this.classList.contains('mobile-grid')) return;
    this.track.style.transform = 'translateX(-' + (this.index * 100) + '%)';
    if (this.dotsWrap) {
      Array.from(this.dotsWrap.children).forEach((d, i) => {
        d.classList.toggle('active', i === this.index);
      });
    }
  }

  startAutoplay() {
    if (!this.autoplaySeconds || this.autoplaySeconds < 1) return;
    if (this.classList.contains('mobile-grid')) return;
    this.timer = setInterval(() => {
      this.index = (this.index + 1) % this.slides.length;
      this.update();
    }, this.autoplaySeconds * 1000);
  }

  restartAutoplay() {
    if (this.timer) clearInterval(this.timer);
    this.startAutoplay();
  }

  bindSwipe() {
    let startX = 0;
    let isDown = false;
    this.track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDown = true;
    }, { passive: true });
    this.track.addEventListener('touchmove', (e) => {
      if (!isDown) return;
    }, { passive: true });
    this.track.addEventListener('touchend', (e) => {
      if (!isDown) return;
      isDown = false;
      const endX = e.changedTouches[0].clientX;
      const diff = startX - endX;
      if (Math.abs(diff) < 40) return;
      if (diff > 0) {
        this.index = Math.min(this.index + 1, this.slides.length - 1);
      } else {
        this.index = Math.max(this.index - 1, 0);
      }
      this.update();
      this.restartAutoplay();
    });
  }
}

customElements.define('porteo-carousel', PorteoCarousel);
